module.exports = __webpack_public_path__ + "assets/home_tab.3a58e022.svg";